export default __webpack_public_path__ + "static/media/abstracto31152.9eaea985.jpg";